import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, Gavel, ListChecks, Truck } from 'lucide-react';

/**
 * Pointer card for the retired Credit & Loans → Secondary surface
 * (ll-construction-surface-redesign.md, Decisions 1/4/5). The sub-tab id is
 * kept so existing deep links resolve; the work itself now lives in its three
 * proper homes.
 */
const SecondaryMovedCard: React.FC = () => {
  const navigate = useNavigate();
  const rows = [
    {
      icon: <Gavel className="w-4 h-4 text-indigo-300" />,
      title: 'Auction construction — BWIC / OWIC',
      body: 'Lists, bids, capacity, surveillance. Pre-trade work lives in the Construction pillar now.',
      cta: 'Open Loan Auctions',
      go: () => navigate('/portfolio-management?tab=construction&lane=auctions'),
    },
    {
      icon: <ListChecks className="w-4 h-4 text-sky-300" />,
      title: 'Trade history',
      body: 'One blotter for the firm — the LL view (with legacy seed history) lives in the main Blotter.',
      cta: 'Open Blotter',
      go: () => navigate('/bond-transactions?assetClass=LL'),
    },
    {
      icon: <Truck className="w-4 h-4 text-emerald-300" />,
      title: 'Loan settlement',
      body: 'LSTA open-trade queue — aging, delayed comp, BISO — runs in Middle Office.',
      cta: 'Open Settlement Queue',
      go: () => navigate('/middle-office?tab=loan-settlement'),
    },
  ];

  return (
    <div className="max-w-2xl">
      <div className="text-[10px] font-bold uppercase tracking-[0.16em] text-slate-500">Surface retired</div>
      <h3 className="text-lg font-semibold text-white tracking-tight mt-0.5 mb-1">Secondary moved to its proper homes</h3>
      <p className="text-xs text-slate-500 mb-4">
        Credit &amp; Loans is the post-trade workspace; auction construction is pre-trade. Nothing was removed — everything relocated.
      </p>
      <div className="space-y-2">
        {rows.map(r => (
          <button
            key={r.title}
            onClick={r.go}
            className="w-full text-left rounded-xl border border-white/5 bg-slate-900/50 hover:bg-white/[0.04] hover:border-white/10 transition-colors px-4 py-3 flex items-center gap-3"
          >
            <div className="w-9 h-9 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center shrink-0">{r.icon}</div>
            <div className="flex-1 min-w-0">
              <div className="text-[13px] font-semibold text-white">{r.title}</div>
              <div className="text-[11px] text-slate-500">{r.body}</div>
            </div>
            <span className="inline-flex items-center gap-1 text-[11px] font-semibold text-indigo-300 shrink-0">
              {r.cta} <ArrowRight className="w-3.5 h-3.5" />
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SecondaryMovedCard;
